var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back arrow",
    clipPath: "url(#clip0_12177_22412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.7631 6.15123C3.37257 5.76071 3.37257 5.12754 3.7631 4.73702L6.02788 2.47224C6.35005 2.15007 6.35004 1.62774 6.02788 1.30557C5.70571 0.983405 5.18338 0.983405 4.86121 1.30557L1.42976 4.73702C1.03924 5.12754 1.03924 5.76071 1.42976 6.15123L4.86121 9.58268C5.18338 9.90485 5.70571 9.90485 6.02788 9.58268C6.35004 9.26052 6.35004 8.73818 6.02788 8.41602L3.7631 6.15123Z",
    fill: "#424446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12177_22412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8889,
    height: 7,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 10.8887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.03c97cf9ae94534cdf99ed6ecffed05a.svg";
export { ForwardRef as ReactComponent };